module.exports = __webpack_public_path__ + "img/product__bell.de946fe4.svg";